import { render, staticRenderFns } from "./updateResource.vue?vue&type=template&id=488fd776&scoped=true"
import script from "./updateResource.vue?vue&type=script&lang=js"
export * from "./updateResource.vue?vue&type=script&lang=js"
import style0 from "./updateResource.vue?vue&type=style&index=0&id=488fd776&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488fd776",
  null
  
)

export default component.exports